var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { primitive } from '../../../../utils/serializr/schema/inner/primitive';
import { deserialize, withDefault } from '../../../../utils/serializr/serializr';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { editable } from '../../../../utils/mobx/decorators/editable';
import { runtime } from '../../../runtime/Runtime';
import { str_replace } from '../../../../utils/helper/helper_string';
import { sleep } from '../../../../utils/helper/helper_time';
import { Ply } from '../ply/Ply';
export class Vid extends Ply {
    type = 'vid';
    youtubeId;
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get src() {
        if (this.youtubeId) {
            return `https://www.youtube.com/watch?v=${this.youtubeId}`;
        }
        if (this.base64.length > 0) {
            this.scheduleForUpload();
            return this.base64;
        }
        let src = `${this.filePath}?version=${this.fileVersion}`;
        if (this.filePath.startsWith('/data2/') && runtime.isBrowserRuntime) {
            // directly stream from node to avoid nginx traffic
            let bandwidthFilePath = this.filePath;
            const { effectiveType } = runtime.solidBrowserRuntime.browserBandwidth;
            if (['2g', 'slow-2g'].includes(effectiveType)) {
                return '';
            }
            if (['3g', '4g'].includes(effectiveType) &&
                !runtime.runtimePermissions.hasEditFunctionality &&
                runtime.solidBrowserRuntime.browserConfig.canPlayVp9) {
                bandwidthFilePath = str_replace('.mp4', '.webm', str_replace('/1/', `/1/${effectiveType}/`, this.filePath));
            }
            src = `https://${runtime.runtimeHostname.nodeHostName}${bandwidthFilePath}?version=${this.fileVersion}`;
            if (typeof window !== "undefined" &&
                window.app &&
                window.app.user &&
                window.app.user.id &&
                window.app.user.id % 2 === 1) {
                src = str_replace("https://node.schlaukopf.de/data2/vid", "https://www.schlaukopf.de/data3/vid", src);
            }
        }
        if (runtime.isBrowserRuntime) {
            const preloadedVideoBlobSrc = runtime.solidBrowserRuntime.browserPreload.getPreloadedVideoBlobSrc(src);
            if (preloadedVideoBlobSrc)
                return preloadedVideoBlobSrc;
        }
        return src;
    }
    get vidEdit() {
        return new runtime.solidPackages.Edit.classes.VidEdit(this);
    }
    static fromSerialized(ser = {}) {
        return deserialize(Vid, ser);
    }
    static get serializeInfo() {
        return {
            extends: Ply.serializeInfo,
            props: {
                youtubeId: withDefault(primitive, ''),
            },
            afterDeserialize: async ({ target, context }) => {
                if (!runtime.solidBrowserRuntime)
                    return;
                // if (context.rootContext.target.type !== 'question') return; only preload question videos?
                if (runtime.browserRuntime.app.appBoot.timeSinceStartup < 6000) {
                    await sleep(5000);
                }
                runtime.runtimeScheduler.scheduleIdleBackgroundTask(() => {
                    if (target.src.includes('/data')) {
                        runtime.solidBrowserRuntime.browserPreload.fetchAndCacheVideo(target.src);
                    }
                });
                if (runtime.runtimePermissions.hasEditFunctionality && ['question', 'bundle'].includes(context.rootContext.target.type)) {
                    context.rootContext.target.measuredAssetSize += Math.ceil(target.fileSize / 1000);
                }
                if (runtime.runtimePermissions.hasEditFunctionality && target.durationInSeconds === 0) {
                    setTimeout(target.vidEdit.detectAndUpdateDuration, 10);
                }
            },
        };
    }
}
__decorate([
    editable()
], Vid.prototype, "youtubeId", void 0);
__decorate([
    override
], Vid.prototype, "src", null);
__decorate([
    memoize
], Vid.prototype, "vidEdit", null);
__decorate([
    memoize
], Vid, "serializeInfo", null);
